import PageOne from "../pages/PageOne";
import PageTwo from "../pages/PageTwo";
import PageThree from "../pages/PageThree";
import PageFive from "../pages/PageFive";

import "../styles/new-design.css"
import PageSix from "../pages/PageSix";
import PageSeven from "../pages/PageSeven";
import PageEight from "../pages/PageEight";
import PageNine from "../pages/PageNine";
import PageTen from "../pages/PageTen";
import PageFour from "../pages/PageFour";

export default function NewHomeDesign() {
    return (

        <div className="purple-background">
            <PageOne />
            <PageTwo />
            <PageThree />
            <PageFour />
            <PageFive />
            <PageSix />
            <PageSeven />
            <PageEight />
            <PageNine />
            <PageTen />

        </div>

    )

}